import 'core-js/es6/reflect';
import 'core-js/es7/reflect';
import 'zone.js/dist/zone';
import 'hammerjs';
import 'web-animations-js';
import {CdkTableModule} from '@angular/cdk/table';

import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import { BrowserModule } from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {downgradeComponent, downgradeInjectable, UpgradeModule} from '@angular/upgrade/static';
import {AppComponent} from './app/app.component';
// import { OfferOverviewComponent } from './app/offer/offer-overview/offer-overview.component';
import { ImpressumComponent } from './app/impressum/impressum.component';
import { AdminUserComponent } from './app/admin/user/admin-user/admin-user.component';
// import {DoorOverviewComponent} from './app/door-overview/door-overview/door-overview.component';
// import {DoorOverviewDirective} from './app/door-overview/door-overview/door-overview.directive';
// import {PresentationOverviewComponent} from './app/presentation-overview/presentation-overview.component';
// import {PresentationOverviewDirective} from './app/presentation-overview/presentation-overview.directive';
// import {OfferOverviewDirective} from './app/offer/offer-overview/offer-overview.directive';
import {ImpressumDirective} from './app/impressum/impressum.directive';
import {AdminUserDirective} from './app/admin/user/admin-user/admin-user.directive';
import {HeaderComponent} from './app/header/index';
import {RouterModule, UrlHandlingStrategy} from '@angular/router';
import {AuthInterceptor} from './app/infrastructure/interceptors/auth.interceptor';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {AuthService, LieferzeitService, LocalizationService2, UserService} from './app/infrastructure/services/index';
import {JwtModule, JwtHelperService} from '@auth0/angular-jwt';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppRoutes} from './app.routes';
import {HomeComponent} from './app/home/home.component';
import {RedirectComponent} from './app/redirect/index';
import {LoginComponent} from './app/login/index';
import {HomeDirective} from './app/home/home.directive';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AuthGuard} from './app/infrastructure/guards/index';
import {FooterComponent} from './app/footer/index';
import { AccessoryCatalogComponent } from './app/configuration/accessory-catalog/accessory-catalog.component';
import {MatFormField, MatFormFieldModule, MatInputModule,
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatDividerModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatStepperModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule} from '@angular/material';
// import {PresentationModule} from './presentation/external/presentation.module';
// import {AppPresentation} from './presentation/external/presentation.component';
import { CookieService } from 'angular2-cookie/services/cookies.service';


declare var angular: any;
angular.module('kompoApp')
  .directive(
    'appHome',
    downgradeComponent({component: HomeComponent})
  );

angular.module('kompoApp')
  .directive(
    'appAccessoryCatalog',
    downgradeComponent({component: AccessoryCatalogComponent})
  );

@NgModule({
  exports: [
    CdkTableModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
  ],
  // declarations: [VordachOverviewTableComponent]
})
export class DemoMaterialModule {}
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
   // DoorOverviewComponent,
   // OfferOverviewComponent,
    HeaderComponent,
    RedirectComponent,
    LoginComponent,
    ImpressumComponent,
    AdminUserComponent,
  //  DoorOverviewDirective,
  //  OfferOverviewDirective,
    ImpressumDirective,
    AdminUserDirective,
    // HomeDirective,
    FooterComponent,
    AccessoryCatalogComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    UpgradeModule,
    HttpClientModule,
    // PresentationModule,
    // AppRoutes,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    DemoMaterialModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          return localStorage.getItem('token');
        }
      }
    })
  ],
  providers: [
    AuthService,
    AuthGuard,
    { provide: 'BASE_URL', useFactory: getBaseUrl },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: '$scope',
      useFactory: i => i.get('$rootScope'),
      deps: ['$injector']
    },
    LocalizationService2,
    JwtHelperService,
    UserService,
    LieferzeitService,
    CookieService
  ],
  entryComponents: [HomeComponent, AccessoryCatalogComponent
     ],
  bootstrap: [AppComponent],
  exports: [
    CdkTableModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
  ]
})
export class AppModule {


}



export function getBaseUrl() {
  return ''; // http:// localhost:1337
  // document.getElementsByTagName('base')[0].href;
}



// WEBPACK FOOTER //
// ./src/components/app.module.ts